import {ReportMaintenanceScheduleModel} from "../../models/reports/ReportMaintenanceScheduleModel";

export class ReportMaintenanceScheduleCtrl {
    public static $inject = ['$scope','ReportMaintenanceScheduleModel'];
    constructor(public $scope:any, public model:ReportMaintenanceScheduleModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.search, this.model.locationName, this.model.locationSite, this.model.startDate, this.model.endDate], (newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
